export const WEATHER_STATIONS_SOURCE_ID = 'weather-stations';
export const WEATHER_STATIONS_POINT_ICONS_LAYER_ID =
  'weather-stations-point-icons-layer';
export const WEATHER_STATIONS_ARROW_ICONS_LAYER_ID =
  'weather-stations-arrow-icons-layer';
export const WEATHER_STATIONS_LABELS_LAYER_ID = 'weather-stations-labels-layer';
export const WEATHER_STATIONS_LABELS_WIND_SPEED_LAYER_ID =
  'weather-stations-labels-wind-speed-layer';
export const WEATHER_STATIONS_LABELS_WIND_GUST_LAYER_ID =
  'weather-stations-labels-wind-gust-layer';
export const WEATHER_STATIONS_SELECTED_POINT_ICON_LAYER_ID =
  'weather-stations-selected-point-icon-layer';
export const SOURCE_LAYER = 'weatherstations_atmospheric';
export const MIN_ICON_ZOOM_LEVEL = 10;
export const MIN_LABEL_ZOOM_LEVEL = 11;
export const MAX_ICON_INTERPOLATION_ZOOM_LEVEL = 13;
export const BASE_CIRCLE_RADIUS = 3.5;
